import React, { useState, useEffect } from "react";
import { Menu, Dropdown, Badge, Avatar, List, Button } from "antd";
import {
  MailOutlined,
  BellOutlined,
  WarningOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import notificationData from "assets/data/notification.data.json";
// import { getToken } from "../../configs/firebase";
import Flex from "components/shared-components/Flex";
import axios from "axios";
import { showToken, onMessageListener } from "configs/FirebaseConfig";

import { env } from "configs/EnvironmentConfig";

const getIcon = (icon) => {
  switch (icon) {
    case "mail":
      return <MailOutlined />;
    case "alert":
      return <WarningOutlined />;
    case "check":
      return <CheckCircleOutlined />;
    default:
      return <MailOutlined />;
  }
};

const getNotificationBody = (list, callback = null) => {
  const Link = (id, type) => {
    axios
      .post(
        env.API + "/notification/notification/read",
        {
          id: [id],
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        callback();
        //
        // if (type == "USER_POINT_REWARD") {
        //   window.location.href = "/anggota/riwayat-bulanan";
        // } else {
        //   window.location.href = "/anggota/home";
        // }
      })
      .catch((e) => {});
  };
  return list.length > 0 ? (
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={list}
      renderItem={(item) => (
        <List.Item
          className="list-clickable"
          style={{ background: item.color }}
        >
          <Flex alignItems="center">
            <div className="pr-3"></div>
            <div
              className="mr-3"
              onClick={() => {
                Link(item.id, item.type);
              }}
            >
              <span className="font-weight-bold text-dark">{item.title} </span>
              <span className="text-gray-light">{item.content}</span>
            </div>
            {/* <small className="ml-auto">{item.created_at}</small> */}
          </Flex>
        </List.Item>
      )}
    />
  ) : (
    <div className="empty-notification">
      <img
        src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg"
        alt="empty"
      />
      <p className="mt-3">You have viewed all notifications</p>
    </div>
  );
};

export const NavNotification = () => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [isTokenFound, setTokenFound] = useState(false);
  const [countNotif, setCountNotif] = useState(0);

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };
  onMessageListener()
    .then((payload) => {
      getData();
    })
    .catch((err) => {});

  const getData = () => {
    axios
      .get(env.API + "/notification/notification?offset=0&limit=25", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const data = res.data.data.data;
        const newData = [];
        let notifCounter = 0;
        data.forEach((d, i) => {
          if (d.read_at == null) {
            d["color"] = "white";
            notifCounter += 1;
            newData.push(d);
          } else {
            d["color"] = "#EEEEEE";
          }
        });
        setData(data);
        setCountNotif(newData.length);
      })
      .catch((e) => {
        setData([]);
      });
  };

  useEffect(() => {
    // setError(true);

    // if (!data.length) {
    showToken(setTokenFound);
    getData();
    // }
  }, []);

  const notificationList = (
    <div className="nav-dropdown nav-notification">
      <div className="nav-notification-header d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Notification</h4>
        {/* <Button
          className="text-primary"
          type="link"
          onClick={() => setData([])}
          size="small"
        >
          Clear{" "}
        </Button> */}
      </div>
      <div className="nav-notification-body">
        {getNotificationBody(data, () => {
          getData();
        })}
      </div>
      {data.length > 0 ? <div className="nav-notification-footer"></div> : null}
    </div>
  );

  return (
    <Dropdown
      placement="bottomRight"
      overlay={notificationList}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      trigger={["click"]}
    >
      <Menu mode="horizontal">
        <Menu.Item key="notification">
          <Badge count={countNotif}>
            <BellOutlined className="nav-icon mx-auto" type="bell" />
          </Badge>
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default NavNotification;
